import { render, staticRenderFns } from "./subpackageProduct.vue?vue&type=template&id=6b1db28b&scoped=true&"
import script from "./subpackageProduct.vue?vue&type=script&lang=js&"
export * from "./subpackageProduct.vue?vue&type=script&lang=js&"
import style0 from "./subpackageProduct.vue?vue&type=style&index=0&id=6b1db28b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1db28b",
  null
  
)

export default component.exports